'use strict';

$(document).ready(() => {
	$(window).on('action:app.load', () => {
		require(['composer', 'hooks', 'native', 'quill-nbb'], (composer, hooks, native) => {
			if (native.mock) {
				// 页面刷新，go 弹窗前的 state
				const rulesRouteState = parseInt(window.localStorage.getItem('rulesRouteState'), 10) || 0;
				const composeRouteState = parseInt(window.localStorage.getItem('composeRouteState'), 10) || 0;
				if (rulesRouteState === 1) {
					window.localStorage.setItem('rulesRouteState', '');
					window.localStorage.setItem('composeRouteState', '');
					window.history.go(-2);
				} else if (composeRouteState === 1) {
					window.localStorage.setItem('rulesRouteState', '');
					window.localStorage.setItem('composeRouteState', '');
					window.history.go(-1);
				}
			}

			$(window).on('action:composer.topic.new', (ev, data) => {
				const composeData = {
					cid: data.cid,
					topicGroupId: data.topicGroupId,
					title: data.title,
				};
				if (native.mock) {
					window.history.pushState({
						compose: true,
						data: composeData,
					}, null);
					window.localStorage.setItem('composeRouteState', '1');
				}
				composer.newTopic(composeData);
			});

			$(window).on('action:composer.post.new', (ev, data) => {
				const composeData = {
					cid: data.cid,
					tid: data.tid,
					toPid: data.pid,
					groupPid: data.groupPid,
					groupIndex: data.groupIndex,
					title: data.topicName,
				};
				if (native.mock) {
					window.history.pushState({
						compose: true,
						data: composeData,
					}, null);
					window.localStorage.setItem('composeRouteState', '1');
				}
				composer.newReply(composeData);
			});
			composer.eventReady = true;
		});
	});
});
